<template>
  <div class="text-left">
    <v-btn
      color="primary"
      dark
      small
      :text="item.tutor_extra !== ''"
      @click="dialog = true"
    >
      <v-icon
        v-if="item.tutor_extra !== ''"
        left
      >
        mdi-pencil
      </v-icon>{{ nameButtom }}
    </v-btn>
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2 text-left">
          Administrar Profesor
        </v-card-title>

        <v-card-text>
          <div v-if="item.tutor_extra === ''">
            <span>
              Invita a un profesor para {{ item.name }}
            </span>
          </div>
          <div v-else>
            <p>
              Profesor actual: <b>{{ item.tutor_extra }}</b>
            </p>
          </div>
          <v-form
            v-show="item.tutor_extra === ''"
            ref="form"
            lazy-validation
            class="py-4 text-center"
          >
            <v-text-field
              v-model="email"
              label="Email"
              class="purple-input"
              prepend-icon="mdi-email"
              :rules="emailRules"
              outlined
            />
          </v-form>

          <!-- <span class="font-weight-bold">
            Permisos para el profesor:
          </span>
          <br>
          <span class="text-caption">Se recomienda autorizar ambos campos*</span>
          <v-checkbox
            v-model="blockLevels"
            :label="blockLevels ? 'Bloquear niveles - Habilitado' : 'Bloquear niveles - Deshabilitado'"
          />
          <v-checkbox
            v-model="viewStatistics"
            :label="viewStatistics ? 'Ver estadísticas de desempeño del alumno' : 'No permitir ver estadísticas de desempeño del alumno'"
          /> -->

        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <div v-if="item.tutor_extra !== ''">
            <!-- <v-btn

              color="primary"
              text
              @click="tutorUpdatePermission"
            >
              Actualizar Permisos
            </v-btn> -->
            <v-btn
              color="secondary"
              text
              @click="tutorEmailRemove"
            >
              Eliminar Profesor
            </v-btn>
            <!-- <v-btn
              color="primary"
              text
              @click="tutorEmailSet"
            >
              Cambiar Tutor
            </v-btn> -->
          </div>
          <v-btn
            v-else
            color="primary"
            text
            @click="tutorEmailSet"
          >
            Enviar Invitación
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    props: {
      item: {
        type: Object,
        default: () => {},
      },
      updateStudent: {
        type: Function,
        default: () => {},
      },
      nameButtom: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        blockLevels: true,
        viewStatistics: true,
        dialog: false,
        email: '',
        emailRules: [
          value => !!value || 'Email es requerido.',
          // value => (value || '').length <= 50 || 'Max 50 caracteres',
          value => (value || '').length <= 50 || 'Máximo 50 caracteres',
          value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Email invalido.'
          },
          v => v !== this.item.tutor_extra_email || 'Email del tutor debe ser diferente al actual.',
        ],
        studentTutorExtraURL: 'https://us-central1-videojuego-sh.cloudfunctions.net/studentTutorExtra',
        studentRemoveTutorURL: 'https://us-central1-videojuego-sh.cloudfunctions.net/studentRemoveTutor',
      }
    },
    computed: {
      ...mapState(['userData', 'user']),
    },
    mounted () {
      this.init()
    },
    methods: {
      init () {
        this.blockLevels = this.item.tutor_extra_permission.blockLevels
        this.viewStatistics = this.item.tutor_extra_permission.viewStatistics
      },
      close () {
        this.$refs.form.reset()
        this.dialog = false
        this.$store.commit('SET_LOADING', false)
      },
      tutorUpdatePermission () {
        const newPermission = {
          studentId: this.item.actions.id,
          blockLevels: this.blockLevels,
          viewStatistics: this.viewStatistics,
        }
        this.$store.dispatch('UPDATE_TUTOR_PERMISION', newPermission)
        this.close()
      },
      async tutorEmailRemove () {
        // if (this.$refs.form.validate()) {
        this.$store.commit('SET_LOADING', true)
        try {
          axios.post(this.studentRemoveTutorURL, {
            uid: this.user.uid, // padre
            student_id: this.item.actions.id, // student id
            tutor_extra_permission: { },
            // tutor_id: this.user.uid
          })
            .then((response) => {
              const data = response.data
              const error = data.error
              this.$store.commit('SET_LOADING', false)
              if (!error) {
                this.updateStudent(this.item.actions.id, null)
                const message = data.message
                alert(message)
                this.email = ''
                this.item.tutor_extra = ''
              } else {
                const message = data.message
                alert(message)
              }
            })

          this.close()
          // ---end try
        } catch (error) {
          var errorCode = error.code
          var errorMessage = error.message
          console.log(errorCode, errorMessage)
          alert(errorMessage)
          this.close()
        }
        // }
      },
      async tutorEmailSet () {
        if (this.$refs.form.validate()) {
          this.$store.commit('SET_LOADING', true)
          const isExist = await this.$store.dispatch('IS_TUTOR_EXIST', this.email)
          if (!isExist) {
            try {
              axios.post(this.studentTutorExtraURL, {
                uid: this.user.uid,
                studentId: this.item.actions.id,
                tutor_extra: this.email,
                tutor_extra_permission: {
                  confirmated: false,
                  blockLevels: this.blockLevels,
                  viewStatistics: this.viewStatistics,
                },
              })
                .then((response) => {
                  const data = response.data
                  const error = data.error
                  this.$store.commit('SET_LOADING', false)
                  if (!error) {
                    this.updateStudent(this.item.actions.id, data.tutor_extra)
                    const message = data.message
                    alert(message)
                    this.email = ''
                  } else {
                    const message = data.message
                    alert(message)
                  }
                })
              this.close()
            } catch (error) {
              var errorCode = error.code
              var errorMessage = error.message
              console.log(errorCode, errorMessage)
              alert(errorMessage)
              this.close()
            }
          } else {
            alert('Email debe estar asociado a algún tutor registrado.')
            this.$store.commit('SET_LOADING', false)
          }
        } else {
          console.log('Faltan datos')
          this.$store.commit('SET_LOADING', false)
        }
      },
    },
  }
</script>
